import styles from './UserProfileField.module.css';

function UserProfileField({ label, id, hint, children }) {
    return (
        <div className={styles.field}>
            <label className={styles.label} htmlFor={id}>{label}</label>
            {children}
            {hint && <p className={styles.hint}>{hint}</p>}
        </div>
    );
}

export default UserProfileField;